import api from './api';

const billService = {
  // Get all bills (landlord)
  getAllBills: (params = {}) => {
    return api.get('/api/bills', { params });
  },

  // Get single bill by ID
  getBillById: (id) => {
    return api.get(`/api/bills/${id}`);
  },

  // Create new bill
  createBill: (data) => {
    return api.post('/api/bills', data);
  },

  // Update bill
  updateBill: (id, data) => {
    return api.put(`/api/bills/${id}`, data);
  },

  // Delete bill
  deleteBill: (id) => {
    return api.delete(`/api/bills/${id}`);
  },

  // Get bills for specific tenant (landlord)
  getTenantBills: (tenantId) => {
    return api.get(`/api/bills/tenant/${tenantId}`);
  },

  // Get current tenant's bills
  getMyBills: (params = {}) => {
    return api.get('/api/bills/me', { params });
  },

  // Convert bill to invoice
  convertToInvoice: (id) => {
    return api.post(`/api/bills/${id}/convert-to-invoice`);
  },

  // Get bill statistics (landlord)
  getBillStatistics: () => {
    return api.get('/api/bills/statistics');
  },
};

export default billService;
